const userInviteStatus = {
    Pending: "0",
    Accepted: "1",
    Expired: "2",
};

export default userInviteStatus;